const Redirect = () => {
    return (
        <div>
            <h2>Sorry, access denied. You are not authorized.</h2>
        </div>
    );
};

export default Redirect;